import type { NotificationType } from "./types";

export const UNREAD_POLL_INTERVAL = 30_000;

export interface InboxSection {
  type: NotificationType;
  title: string;
}

// system в MVP не показываем — бэк его пока не создаёт.
export const INBOX_SECTIONS: InboxSection[] = [
  { type: "news", title: "News" },
  { type: "ticket_reply", title: "Tickets" },
];
